
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exchange/[pair]",
      function () {
        return require("private-next-pages/exchange/[pair]/index.p.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exchange/[pair]"])
      });
    }
  